export default __webpack_public_path__ + "static/media/J.171e1bb8.jpg";